import createRoute        from '@widesk-ui/tools/createRoute';
import EntertainmentModel from '@models/shop/EntertainmentModel';

export default createRoute.dashboard('/entertainments', 'shop', 'EntertainmentDashboard', EntertainmentModel.localize());
